/* JWT / JWK */
export const ERROR_FAILED_FETCH_PUBLIC_KEY = 'Failed to fetch public key.';
export const JWT_HASHING_ALGORITHM = 'SHA-256';
export const RSA_ALGORITHM = 'RSASSA-PKCS1-v1_5';
/* User Groups */
export const USER_GROUP_AFFILIATE = 'affiliate';
export const USER_GROUP_AEROPLAN = 'aeroplan';
export const USER_GROUP_B2B = 'b2b';
export const USER_GROUP_B2B_ADMIN = 'admin_b2b';
export const USER_GROUP_B2B_AGENT = 'agent_b2b';
export const USER_GROUP_EMPLOYEE = 'employee';
export const USER_GROUP_FANDF = 'fandf';
export const USER_GROUP_GUEST = 'guest';
/* Analytics Tracking */
export const DATA_LAYER_ERROR_EVENT = 'errorDL';
export const DATA_LAYER_VIEW_ITEM_LIST_EVENT = 'view_item_list';
export const DATA_LAYER_EEC_PRODUCT_IMPRESSION_EVENT = 'eec-productImpressions';
export const DATA_LAYER_SEARCH_RESULTS = 'searchResults';
export const PACKAGE_SEARCH_RESULTS = 'Package Search Results';
export const VACATION_PACKAGE = 'Vacation Package';

export const DATA_LAYER_VIEW_ITEM_EVENT = 'view_item';
export const DATA_LAYER_VIEW_PRODUCT_DETAILS = 'eec-productDetails';

export const DATA_LAYER_ADD_TO_CART_EVENT = 'add_to_cart';
export const DATA_LAYER_EEC_ADD_TO_CART_EVENT = 'eec-addToCart';

export const DATA_LAYER_BEGIN_CHECKOUT_EVENT = 'begin_checkout';
export const DATA_LAYER_EEC_CHECKOUT_EVENT = 'eec-checkout';

export const DATA_LAYER_FLIGHT_CONT_BOOKING = 'flight_cont_booking';

export const DATA_LAYER_SELECTED_ROOM_CLICK = 'pdpSelect';
export const DATA_LAYER_ANCILLARY_CONT_BOOKING = 'ancillary_cont_booking';

export const DATA_LAYER_PASSENGER_INFO = 'add_passenger_info';

export const UNASSIGNED = 'UNASSIGNED';

export const BOOKING_FORM = 'BOOKING_FORM';
export const PDF_FORM = 'PDF_FORM';
export const CUSTOMER_FORM = 'CUSTOMER_FORM';

export const STATUS_OPEN = 'OPEN';
export const STATUS_CLOSED = 'CLOSED';
export const STATUS = 'STATUS';
export const INSTA = 'INSTA';

export const VOUCHER = 'VOUCHER';
export const VOUCHER_CONTENT = 'PDF_VOUCHER';
export const SIGNATURE_CLIENT = 'SIGNATURE_CLIENT';
export const SIGNATURE_OWNER = 'SIGNATURE_OWNER';

export const NEW = 'NEW';
export const IN_PROGRESS = 'IN_PROGRESS';
export const QUOTE_READY = 'QUOTE_READY';
export const RQ_TO_BOOK = 'RQ_TO_BOOK';
export const BOOKED = 'BOOKED';
export const DEPOSIT_DUE = 'DEPOSIT_DUE';
export const COMPLETE_NAMES = 'COMPLETE_NAMES';
export const FINAL_PAYMENT_DUE = 'FINAL_PAYMENT_DUE';
export const BOOKING_COMPLETED = 'BOOKING_COMPLETED';
export const COMPLETED = 'COMPLETED';
export const EXPIRED = 'EXPIRED';
export const VOID = 'VOID';
export const BOOKING_CANCELLED = 'BOOKING_CANCELLED';
export const PRICE_MATCH = 'PRICE_MATCH';

export const EN_FORMAT_CURRENCY = '$##,###.##';
export const FR_FORMAT_CURRENCY = '## ###,## $';
export const CO_EMAIL = 'CO_EMAIL';

export const ASSIGNED_TO = 'ASSIGNED_TO';

export const QUOTE_STS = 'QUOTE_STS';

export const DEPT_STS = 'DEPT_STS';

export const DEPT = 'DEPT';

export const ASSIGNEE = 'ASSIGNEE';

export const JOSEPH_NADER = 'Joseph Nader';

export const FL = 'FL';
export const RM = 'RM';
export const LANG_ENGLISH = 'en';
export const LANG_FRENCH = 'fr';
export const CURRENCY_USD = 'USD';

export const OUTBOUND = 'Outbound';
export const INBOUND = 'Inbound';

export const STATUS_ERROR = 'ERROR';

export const INCENTIVE_GROUP_TYPE = 'Incentive / Corporate';

export const URL_FLIGHT_EN = 'https://vacations.aircanada.com/en/travel-info/where-we-fly';
export const URL_FLIGHT_FR = 'https://vacations.aircanada.com/fr/infos-de-voyage/destinations-de-nos-vols';

export const PACKAGE_LAND_ONLY = 'PACKAGE_LAND_ONLY';
export const LAND_ONLY_PACKAGE = 'LAND_ONLY_PACKAGE';
export const PACKAGE = 'PACKAGE';
export const TOUR = 'MDT';
export const LAND_ONLY = 'LAND_ONLY';
export const NONE = 'NONE';

export const CREATED = 'CREATED';
export const DEPARTURE_DATE = 'DEPARTURE_DATE';

export const TYPE_BEST_PRICE = 1;
export const TYPE_PRICE_BOOKED = 2;

export const NOT_CHECK_STATUS = -1;

export const ECONOMY = 'ECONOMY';
export const BUSINESS = 'BUSINESS';

export const ERR_NETWORK = 'ERR_NETWORK';

export const AIRPORT = 'AIRPORT';
export const SUB_REGION = 'SUB_REGION';
export const REGION = 'REGION';

export const AIR_TYPE = 'Air';
export const HOTEL_TYPE = 'Hotel';
export const PACKAGE_TYPE = 'Package';
export const TOUR_TYPE = 'Tour';
export const MULTI_TOURS = 'MULTI_TOURS';
export const CRUISE_TYPE = 'Cruise';

export const AFR = 'AFR';
export const ASI = 'ASI';
export const CRU = 'CRU';
export const EUR = 'EUR';
export const MID = 'MID';
export const NAM = 'NAM';
export const SOM = 'SOM';
export const SOP = 'SOP';
export const SUN = 'SUN';

export const ROUNDTRIP = 'ROUND_TRIP';
export const OPENJAW = 'OPEN_JAW';
export const ONEWAY = 'ONE_WAY';

export const PACKAGE_MANAGEMENT = 'PACKAGE_MANAGEMENT';
export const HOTEL_MANAGEMENT = 'HOTEL_MANAGEMENT';
export const AIR_MANAGEMENT = 'AIR';
export const TOUR_MANAGEMENT = 'TOUR_MANAGEMENT';
export const CRUISE_MANAGEMENT = 'CRUISE_MANAGEMENT';
export const TERM_AND_CONDITIONS = 'TERM_AND_CONDITIONS';
export const HOTEL_CONFIGURATION = 'HOTEL';
export const PACKAGE_CONFIGURATION = 'PACKAGE';
export const GATEWAY_MANAGEMENT = 'GATEWAY';
export const DESTINATION_MANAGEMENT = 'DESTINATION';
export const FLIGHT_RULE_MANAGEMENT = 'FLIGHT_RULE';
export const DESTINATION_GROUP_MANAGEMENT = 'DESTINATION_GROUP';
export const GATE_DEST_DURATION_MANAGEMENT = 'GATE_DEST_DURATION';
export const TOUR_COMBINATION = 'TOUR_COMBINATION';
export const TOUR_DETAIL = 'TOUR_DETAIL';
export const CITY = 'CITY';
export const CRUISE_DESTINATION = 'CRUISE_DESTINATION';
export const CRUISE_LINES = 'CRUISE_LINES';
export const CRUISE_SHIPS = 'CRUISE_SHIPS';
export const CRUISE_SAILINGS = 'CRUISE_SAILINGS';
export const CUSTOMER_QUOTE_FORM = 'CUSTOMER_FORM';
export const PDF = 'PDF_FORM';
export const QUOTE_TO_BOOK_TERM = 'BOOKING_FORM';
export const PROMOS = 'PROMOS';
export const HOME_PAGE = 'H_PAGE';
export const TOP_BANNER = 'TOP_BANNER';
export const SIDE_PROMOS = 'SIDE_PROMOS';
export const PROMO_BOX = 'PROMO_BOXES';
export const FORM_PROMOS = 'FORM_PROMOS';
export const SURFACE_PROMO = 'SURFACE_PROMO';
export const ACCORDION_PROMOS = 'ACCORDION_PROMOS';
export const QUOTE_CONFIGURATION = 'QUOTE_CONFIGURATION';
export const PROMO_TITLE_CONFIG = 'PROMO_TITLE_CONFIG';
export const URL = 'URL_CONFIGURATION';
export const EMAIL = 'EMAIL_URL_CONFIG';
export const AGENCY_BLACKLIST = 'AGENCY_BLACKLIST';
export const VOUCHER_TEMPLATE = 'EMAIL_TEMPLATE';
export const FTV_ADMIN = 'SIGNATURE';
export const RULE_ASSIGNMENT = 'RULE_ASSIGNMENT';
export const ADMIN_SETUP = 'ADMIN_SETUP';
export const CONTENT_MANAGEMENT_UPDATE = 'CONTENT_MANAGEMENT_UPDATE';
export const DATA_SYNC = 'SYNC_DATA';
export const AIRLINE_MANAGEMENT = 'AIRLINE_MANAGEMENT';
export const LOGO = 'AIRLINE';
export const AIRLINE_TAX = 'AIRLINE_TAX';
export const GROUP_TYPE_MANAGEMENT = 'GROUP_TYPE';
export const ROLE = 'FEATURE_ROLES';
export const TRAVEL_HOME = 'ADVANCE_QUOTE';
export const MY_QUOTE = 'MY_QUOTE';
export const QUOTE_MANAGEMENT =
  'QUOTE_MANAGEMENT,WORKSHEET_AIR_ONLY,WORKSHEET_CRUISE,WORKSHEET_HOTEL,WORKSHEET_PACKAGE,WORKSHEET_PACKAGE_ADDITIONAL,WORKSHEET_TOUR_ADDITIONAL,WORKSHEET_TOUR_FLIGHT_HEADER,WORKSHEET_TOUR_HOTEL_HEADER,WORKSHEET_TOUR_OTHER_SECTION,WORKSHEET_TOUR_QUOTE_HEADER';
export const ADMINISTRATION = 'CONFIGURATION_PAGE,AIR_CONFIGURATION,GATEWAY_CONFIGURATION,DESTINATION_CONFIGURATION,FLIGHT_RULE_CONFIGURATION,GATE_DURATION_CONFIGURATION,HOTEL_CONFIGURATION,TOUR_COMBINATION_CONFIGURATION,TOUR_DETAIL_CONFIGURATION';
export const REPORT = 'REPORT';
export const EMAIL_CONFIGURATION = 'EXPIRY_CONFIG_EMAIL';
export const OPTION_CONFIGURATION = 'OPTION_CONFIG';
export const EXPIRY_CONFIGURATION = 'EXPIRY_CONFIG_MDT,EXPIRY_CONFIG_PACKAGE,EXPIRY_CONFIG_HOTEL,EXPIRY_CONFIG_CRUISE,EXPIRY_CONFIG_AIR,SPECIAL_PROMO_CONFIG';
export const MAX_ROOM_CONFIGURATION = 'MAX_ROOMS_CONFIG,GROUP_SIZE_CONFIG';
export const MAX_ROOM = 'MAX_ROOMS_CONFIG';
export const GROUP_SIZE = 'GROUP_SIZE_CONFIG';
export const OPEN_JAW_CONFIGURATION = 'JAW_TYPE_DATA';
export const CALENDAR_CONFIGURATION = 'DEPARTURE_CONFIG_START,DEPARTURE_CONFIG_END';
export const MARGIN_SAFETY = 'NET_MARGIN';
export const FTV_CONFIGURATION = 'EMAIL_TEMPLATE, SIGNATURE';
export const FULL_RISK = 'Full Risk';
export const SHARED_RISK = 'Shared Risk';
export const FBR = 'FBR';
export const PRE_REG = 'Pre Reg';

export const EMAIL_DEPOSIT_DUE = 'EMAIL_DEPOSIT_DUE';
export const EMAIL_FINAL_PAYMENT_DUE = 'EMAIL_PAYMENT_DUE';
export const EMAIL_PASSENGER_LIST_DUE = 'EMAIL_PASSENGER_LIST_DUE';
export const EMAIL_QUOTE_EXPIRING = 'EMAIL_QUOTE_EXPIRING';

export * from './quoteTypes';
export * from './voucher';
export * from './worksheet';
export * from './configurableItem';
export * from './tour';
